import { FunctionComponent } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'

import { Loader } from '@matillion/component-library'

import { AppRoutes } from 'constants/route'
import { useGetProjects } from 'api/hooks'
import ProjectsListing from 'modules/Projects/ProjectsListing'
import { useClearSessionStorageForms } from 'hooks/clearSessionStorageForms'
import { useGetProjectsStatus } from 'api/hooks/useGetProjectsStatus'
import { NoResourcesAvailable } from 'components/NoResourcesAvailable'
import { useTranslation } from 'react-i18next'

const ProjectsDashboard: FunctionComponent = () => {
  const { data: projectsData, isLoading } = useGetProjects()
  const { data: projectsStatus, isLoading: projectsStatusLoading } =
    useGetProjectsStatus()
  useClearSessionStorageForms()
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (isLoading || projectsStatusLoading) {
    return <Loader />
  }

  if (projectsStatus?.followOnboarding) {
    return <Navigate to={AppRoutes.getOnboarding()} />
  }

  return projectsData?.length ? (
    <ProjectsListing />
  ) : (
    <NoResourcesAvailable
      title={t('createProject.title')}
      supportText={t('createProject.supportText')}
      buttonText={t('createProject.buttonText')}
      onButtonClick={() => navigate(AppRoutes.getProjectsAdd())}
      data-testid="no-projects-available"
    />
  )
}

export default ProjectsDashboard
